jQuery(document).ready(function ($) {
    /**
     * Сброс полей формы при закрытии модального окна
     */
    $('.modal').on('hide.bs.modal', function () {

        let form = $(this).find('form');

        if (form.length > 0) {
            resetForm(form);
        }

        $('#place-map').empty();
    });

    /**
     * При нажатии на кнопку "Да" в модальном окне выбора города
     * получаем data-атрибуты, сохраняем куку и перезагружаем страницу
     */
    $('#region_modal').on('click', '.yes_btn', function () {
        let data = {
            name: $(this).data('name'),
            title: $.trim($(this).data('title'))
        };

        setCookie('selectedCity', data);
        location.reload();
        // window.location.replace(window.location.origin + '/' + data.name);
    });

    /**
     * При нажатии на ссылки города в подвале и в шапке
     * получаем data-атрибуты, сохраняем куку и перезагружаем страницу
     */
    $('.modal_city, .footer .cities, #filter .filter_title').on('click', 'a', function (event) {
        event.preventDefault();

        let data = {
            name: $(this).data('name'),
            title: $.trim($(this).text())
        };

        setCookie('selectedCity', data);
        // window.location.replace(window.location.origin + '/' + data.name);
        window.location.assign(window.location.origin + '/' + data.name);
    });

    /**
     * Если сауна не находится в избранном, то добавляем в cookies
     * Если находится в избранном - удаляем из cookies
     */
    $('.places_cont, .page2_full .statistic, .city__saunas').on('click', '.like', function () {

        const button = $(this);
        let saunaId = button.attr('data-saunaid');
        let saunas = [];

        if (getCookie('saunaFavorites')) {
            saunas = $.parseJSON(getCookie('saunaFavorites'));
        }

        let item = $.grep(saunas, function (item) {
            return item.id === saunaId;
        });

        if (!item.length) {
            saunas.push({'id': saunaId});
            button.addClass('active');
            button.find('span').text('В избранном');
        } else {
            button.removeClass('active');
            saunas = saunas.filter(function (item) {
                return item.id !== saunaId;
            });

            button.find('span').text('Добавить в избранное');
        }

        setCookie('saunaFavorites', saunas);

        if (button.hasClass('delete_favorite')) {
            location.reload();
        }
    });

    /* Включаем функционал отображения popover при нажатии */
    $(function () {
        $('[data-toggle="popover"]').popover()
    })
});
